/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

// Absolute import
import React from 'react';
import PropTypes from 'prop-types';
import bootstrap from 'bootstrap/dist/css/bootstrap.css';
import { connect } from 'react-redux';
import { Row, Col } from 'reactstrap';
// Relative import
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from '../Order.sass';
import { getOrderPrice } from '../../../api/order';
import { setOrderPriceBreakdownDetail } from '../../../actions/order';
import { setIsShowExtraMessageDialog } from '../../../actions/dialog';

class Order19Total extends React.Component {
  static propTypes = {
    currentLocale: PropTypes.string.isRequired,
    orderDetailInfo: PropTypes.shape().isRequired,
    setOrderPriceBreakdownDetail: PropTypes.func.isRequired,
    setIsShowExtraMessageDialog: PropTypes.func.isRequired,
    modelDataText: PropTypes.shape().isRequired,
    address: PropTypes.arrayOf(
      PropTypes.shape({
        address: PropTypes.string,
        lat: PropTypes.number,
        lon: PropTypes.number,
      }),
    ).isRequired,
    // order: PropTypes.shape({
    //   vehicle: PropTypes.string,
    //   orderPriceBreakdownDetail: PropTypes.shape(),
    // }),
    orderPriceBreakdownDetail: PropTypes.shape({
      extra_message: PropTypes.string,
    }).isRequired,
  };
  static defaultProps = {
    // order: {},
    // coupon_code: '',
  };
  constructor(props) {
    super(props);
    this.state = {
      price: 0,
      isGetPrice: false,
      isKorea: ['kr'].includes(props.currentLocale.split('-')[1].toLowerCase()),
      // routes: [],
      // orderDetailInfo: props.orderDetailInfo,
    };
    this.getPrice = this.getPrice.bind(this);
    this.getRouteNumber = this.getRouteNumber.bind(this);
    this.checkIsValidAddress = this.checkIsValidAddress.bind(this);
    // this.setOrderDetailInfo = this.setOrderDetailInfo.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    let isGetPrice = false;
    isGetPrice = this.isGetPrice(
      this.props.orderDetailInfo.service_type,
      nextProps.orderDetailInfo.service_type,
    );
    isGetPrice =
      isGetPrice ||
      this.isGetPrice(
        this.props.orderDetailInfo.vehicle,
        nextProps.orderDetailInfo.vehicle,
      );
    isGetPrice =
      isGetPrice ||
      this.isGetPrice(
        this.props.orderDetailInfo.pickup_time,
        nextProps.orderDetailInfo.pickup_time,
      );
    isGetPrice =
      isGetPrice ||
      this.isGetPrice(
        this.props.orderDetailInfo.goods,
        nextProps.orderDetailInfo.goods,
      );
    isGetPrice =
      isGetPrice ||
      this.checkRemark(
        this.props.orderDetailInfo.order_request_detail_attributes,
        nextProps.orderDetailInfo.order_request_detail_attributes,
      );
    isGetPrice =
      isGetPrice ||
      this.isGetPrice(
        this.props.orderDetailInfo.routes,
        nextProps.orderDetailInfo.routes,
      );
    isGetPrice =
      isGetPrice ||
      this.isGetPrice(
        this.props.orderDetailInfo.waypoints_attributes,
        nextProps.orderDetailInfo.waypoints_attributes,
      );

    isGetPrice =
      isGetPrice ||
      this.isGetPrice(
        this.props.orderDetailInfo.coupon_code,
        nextProps.orderDetailInfo.coupon_code,
      );

    if (isGetPrice) {
      setTimeout(() => {
        this.getPrice();
      }, 800);
    }
  }

  getRouteNumber() {
    const count = [];
    for (let i = 0; i < this.props.address.length; i += 1) {
      count.push(i + 1);
    }
    return count;
  }

  getPrice() {
    if (this.checkIsValidAddress()) {
      this.props.orderDetailInfo.routes = this.getRouteNumber();
      getOrderPrice(this.props.orderDetailInfo, this.props.currentLocale)
        .then(response => response.json())
        .then(result => {
          if (typeof result.extra_message !== 'undefined') {
            if (this.props.orderPriceBreakdownDetail.extra_message === '') {
              this.props.setIsShowExtraMessageDialog();
            } else if (
              result.extra_message !==
              this.props.orderPriceBreakdownDetail.extra_message
            ) {
              this.props.setIsShowExtraMessageDialog();
            }
          }
          this.props.setOrderPriceBreakdownDetail(result);
          this.setState({ price: result.total });
          this.forceUpdate();
        })
        .catch(error => {
          console.warn('Request failed', error);
        });
    }
  }

  // detect whether need to fetch new price from server
  isGetPrice(oldItem, newItem) {
    if (oldItem === newItem) {
      this.setState({ isGetPrice: false || this.state.isGetPrice });
      return false;
    }
    this.setState({ isGetPrice: true });
    return true;
  }

  // remove remark and remark_for_admin
  /* eslint-disable class-methods-use-this */
  removeRemark(item) {
    const newItem = JSON.parse(JSON.stringify(item));
    const r = 'remark';
    const r1 = 'remark_for_admin';
    delete newItem[r];
    delete newItem[r1];
    return newItem;
  }

  checkRemark(oldItem, newItem) {
    const oldItem2 = this.removeRemark(oldItem);
    const newItem2 = this.removeRemark(newItem);
    // tostring to check 2 object which without remark or remark_for_admin
    return !(JSON.stringify(oldItem2) === JSON.stringify(newItem2));
  }

  checkIsValidAddress() {
    let getPrice = true;
    if (this.props.address.length > 0) {
      // check first address whether is not volid
      for (let i = 0; i < 2; i += 1) {
        if (this.props.address[i].address === '') {
          this.setState({ price: 0 });
          getPrice = false;
        }
      }
    } else {
      getPrice = false;
    }
    return getPrice;
  }

  render() {
    return (
      <Row>
        <Col className={s.orderPricingTotal}>
          {this.props.modelDataText.price_total_amount}
        </Col>
        <Col className={s.orderPricingTotalPrice}>
          {this.state.price === 0 || typeof this.state.price === 'undefined'
            ? '--'
            : !this.state.isKorea
              ? `${this.props.modelDataText.dollar_code} ${this.state.price}`
              : `${this.state.price} ${this.props.modelDataText.dollar_code}`}
        </Col>
      </Row>
    );
  }
}
const mapState = state => ({
  currentLocale: state.intl.locale,
  address1: state.quoting.address1,
  address2: state.quoting.address2,
  address: state.order.address,
  vehicle: state.order.vehicle,
  order: state.order,
  tunnel: state.order.tunnel,
  vehiclePrice: state.quoting.vehiclePrice,
  passenger_count: state.order.passenger_count,
  pickup_time: state.order.pickup_time,
  need_over_6ft: state.order.need_over_6ft,
  cart_count: state.order.cart_count,
  need_cart: state.order.need_cart,
  remove_net: state.order.remove_net,
  need_carry: state.order.need_carry,
  need_new_car: state.order.need_new_car,
  need_pet: state.order.need_pet,
  need_waste: state.order.need_waste,
  pay_by_receiver: state.order.pay_by_receiver,
  coupon_code: state.order.coupon_code,
  orderPriceBreakdownDetail: state.order.orderPriceBreakdownDetail,
  orderDetailInfo: state.order.orderDetailInfo,
});

const mapDispatch = {
  getOrderPrice,
  setOrderPriceBreakdownDetail,
  setIsShowExtraMessageDialog,
};
export default connect(mapState, mapDispatch)(
  withStyles(bootstrap, s)(Order19Total),
);



// WEBPACK FOOTER //
// ./src/routes/order/Order19Total/Order19Total.js